import React from "react";
import {ArrowLeft} from "lucide-react";
import Tooltip from "./Tooltip.tsx";

interface QuoteHeaderProps {
    loanId: string;
    quoteId: number;
    onBack: () => void;
}

const QuoteHeader: React.FC<QuoteHeaderProps> = ({ loanId, quoteId, onBack }) => (
    <div className="flex items-center">
        <Tooltip text='Back'>
            <button
                onClick={onBack}
                className="mr-4 text-slate-600 hover:text-blue-600 transition-colors duration-200 hover:cursor-pointer"
            >
                <ArrowLeft className="h-8 w-8 text-blue-700" />
            </button>
        </Tooltip>
        <div>
            <h1 className="text-2xl font-bold text-slate-900">Loan # {loanId}</h1>
            <p className="text-sm text-slate-500">Quote ID: {quoteId}</p>
        </div>
    </div>
);

export default QuoteHeader;